import { createAsyncStore } from "../common/axios/asyncModel";
import { FaqRepository, FaqParams } from "repository/faqRepository";

const faqList = createAsyncStore();
const faqDetail = createAsyncStore();

const getFaqList = (params: FaqParams) => {
    faqList.onGetAll(() => FaqRepository.onGetFaqList(params))
}

const getFaqDetail = (faqNo: number, serviceId: String) =>{
    faqDetail.onGetAll(()=> FaqRepository.onGetFaqDetail(faqNo, serviceId));
}

export const faqStore = {
    faqList,
    faqDetail,
    getFaqList,
    getFaqDetail,
}
